import { COLORS } from '../../../assets/utils/enums/colors';
import { errorPageData, ErrorPageProps } from '../../../assets/utils/enums/error-page'
import { LabelText, LittleSubHeadline } from '../../typography';
import { Button } from '../../ui/button';
import { ErrorBlock } from '../../ui/table';
import AppLayout from './layout';

export default function ErrorPage({
    variant,
    title,
    description,
    actionText = "Повернутися назад",
    additionalBtn,
    onAction,
    onActionAddBtn
}: ErrorPageProps) {


    return (
        <AppLayout className="d-flex flex-column align-items-center" blockType="details-project">
            <ErrorBlock className="w-100 d-flex flex-column gap-2 align-items-start">
                <LabelText>{title ?? errorPageData[variant].title}</LabelText>
                <LittleSubHeadline>{description ?? errorPageData[variant].description}</LittleSubHeadline>

                {onAction && (
                    <span className='w-50 d-flex gap-2'>
                        <Button
                            bgcolor={"transparent"}
                            txtcolor={COLORS['bg-text-color']}
                            brcolor={COLORS['bg-text-color']}
                            width="auto"
                            type="large"
                            brradius="24px"
                            className="px-4 my-3 border-2"
                            onClick={onAction}
                        >
                            <LittleSubHeadline>{actionText}</LittleSubHeadline>
                        </Button>
                        {additionalBtn && <Button
                            bgcolor={COLORS.blue}
                            txtcolor={COLORS.white}
                            brcolor={"transparent"}
                            width="auto"
                            type="large"
                            brradius="24px"
                            className="px-4 my-3"
                            onClick={onActionAddBtn}
                        >
                            <LittleSubHeadline>{additionalBtn}</LittleSubHeadline>
                        </Button>}
                    </span>
                )}
            </ErrorBlock>
        </AppLayout>
    );
};
